import { MarkdownLink } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

interface MdxLinkProps {
  href?: string;
}

const MdxMdxLink: FC<PropsWithChildren<MdxLinkProps>> = ({
  href = '',
  children,
}) => {
  return <MarkdownLink href={href}>{children}</MarkdownLink>;
};

MdxMdxLink.displayName = 'MdxLink';

export { MdxMdxLink };
